import React, { useEffect, useState } from 'react';
import useUpload from './useUpload';
import { useDispatch } from 'react-redux';
import { sendMessage } from 'store/messages/messages.actions';
import style from './upload-file.module.scss';
import { setCSSVar } from 'utils';
import useMessages from 'hooks/useMessages';
import { setUploadFileAttribute } from 'services/api';
import useApp from 'hooks/useApp';

interface Props { }

interface SAFileUploadMessage {
    type: 'TEXT',
    text: string
    inputType: 'FILE_UPLOAD',
    attributeName?: string,
    company: string,
    contactID: string,
    instanceARN: string,
    env: string
}

const UploadFile: React.FC<Props> = props => {
    const messagesState = useMessages();
    const uploadFileMessage = messagesState[messagesState.length - 1].content as SAFileUploadMessage | undefined
    console.log('upload file message: ', uploadFileMessage)
    const attributeName = uploadFileMessage?.attributeName ? uploadFileMessage?.attributeName : undefined
    const [file, setFile] = useState<File>();

    const [uploadText, setUploadText] = useState<string>('Upload a file...');
    console.log('upload text: ', uploadText)
    const [loading, , progress, upload] = useUpload(setUploadText);

    const { company, contactID, instanceID } = useApp();

    const dispatch = useDispatch();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) return;
        setFile(e.target.files[0]);
        setUploadText(e.target.files[0].name);
    };

    const onClick = (file: File) => {
        upload(file!, attributeName);
    };

    const handleNoUpload = async () => {
        if (instanceID && contactID && attributeName) {
            await setUploadFileAttribute(company, instanceID, contactID, { [attributeName]: 'NULL' });
        }
        dispatch(sendMessage("I don't have a file"));
    };

    useEffect(() => {
        setCSSVar('--chat-upload-progress-percent', progress + '%');
        return () => setCSSVar('--chat-upload-progress-percent', '0%');
    }, [progress]);

    return (
        <div className={style.container}>
            <input className={style.fileInput} id="file-upload" onChange={onChange} type="file" />
            <label className={style.fileUploadLabel} htmlFor="file-upload">
                {typeof uploadText === 'string' ? uploadText : 'Error uploading file'}
            </label>


            <button className={style.uploadButton} onClick={() => handleNoUpload()}>
                No upload
            </button>
            <button className={style.uploadButton} disabled={!file || loading} onClick={() => onClick(file!)}>
                Upload
            </button>
        </div>
    );
};

export default UploadFile;
